import { render, staticRenderFns } from "./IndividualRecords.vue?vue&type=template&id=f3df67a0"
import script from "./IndividualRecords.vue?vue&type=script&lang=js"
export * from "./IndividualRecords.vue?vue&type=script&lang=js"
import style0 from "./IndividualRecords.vue?vue&type=style&index=0&id=f3df67a0&prod&lang=sass"
import style1 from "./IndividualRecords.vue?vue&type=style&index=1&id=f3df67a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports